module.exports = __webpack_public_path__ + "static/media/traffic-barrier.6152d8d9.svg";